import { Td } from '@chakra-ui/react'

export const RowsDoubleRowNameCell = ({ rowName }) => {
	return <Td>{rowName}</Td>
}
